import { Icon, IconButton, SidebarPriorityItem } from '@monash/portal-react';
import React from 'react';
import c from './search-button.module.scss';

const SearchButton = ({ isInSidebar = false }) => {
  const LABEL = 'Search';

  return isInSidebar ? (
    <SidebarPriorityItem
      icon={<Icon.Search />}
      size={24}
      aria-label={LABEL}
      role="search"
      element="a"
      href="/search?query="
      className={c.sidebarView}
    >
      {LABEL}
    </SidebarPriorityItem>
  ) : (
    <IconButton
      icon={Icon.Search}
      size={24}
      aria-label={LABEL}
      role="search"
      element="a"
      href="/search?query="
    />
  );
};

export default SearchButton;
